import React from 'react';

const PropertyCardSkeleton = ({ label = 'Loading property' }) => (
  <article className="property-card property-card--skeleton" aria-label={label} aria-busy="true">
    <div className="property-image property-skeleton__image">
      <span className="property-skeleton property-skeleton__badge" />
    </div>
    <div className="property-content">
      <div className="property-meta property-skeleton__meta">
        <span className="property-skeleton property-skeleton__line property-skeleton__line--location" />
        <span className="property-skeleton property-skeleton__line property-skeleton__line--city" />
      </div>
      <div className="property-skeleton property-skeleton__line property-skeleton__line--title" />
      <div className="property-skeleton__description">
        <span className="property-skeleton property-skeleton__line" />
        <span className="property-skeleton property-skeleton__line property-skeleton__line--description-short" />
      </div>
      <div className="property-specs property-skeleton__specs">
        <span className="property-skeleton property-skeleton__line property-skeleton__line--spec" />
        <span className="property-skeleton property-skeleton__line property-skeleton__line--developer" />
      </div>
      <div className="property-footer property-skeleton__footer">
        <span className="property-skeleton property-skeleton__line property-skeleton__line--price" />
        <span className="property-skeleton property-skeleton__line property-skeleton__line--enquire" />
      </div>
      <div className="property-skeleton property-skeleton__viewing" />
    </div>
  </article>
);

export default PropertyCardSkeleton;
